export const WHATSAPP_SETUP_TYPE = 'whatsapp_marketing_setup';
export const AUTOMATION_IDS = ['cart', 'stock', 'cod_confirmation', 'order', 'shipping', 'delivery', 'custom'];
const NOTIFICATIONS = ['order', 'shipping', 'delivery'];

// TR and EN send tariffs are deliberately independent; package prices use 50 TRY/USD.
export function getWhatsAppQuote(locale, selected = []) {
  const tr = locale === 'tr';
  const ids = AUTOMATION_IDS.filter(id => Array.isArray(selected) && selected.includes(id));
  const unit = tr ? 2000 : 40;
  const bundle = NOTIFICATIONS.every(id => ids.includes(id));
  const discount = bundle ? unit * 3 * 0.4 : 0;
  const base = tr ? 3950 : 79;
  const automations = ids.length * unit - discount;
  return {
    currency: tr ? 'TRY' : 'USD', selected: ids, base, unit, bundle, discount,
    automations, monthly: base + automations,
    setup: ids.includes('custom') ? (tr ? 2500 : 50) : 0,
    marketingPer100: tr ? 40 : 0.70, utilityPer100: tr ? 6 : 0.12,
    vatIncluded: true, metaFeesIncluded: false,
  };
}

export function normalizeStoreUrl(value) {
  const text = typeof value === 'string' ? value.trim() : '';
  if (!text || text.length > 500) return null;
  try {
    const url = new URL(/^[a-z][a-z\d+.-]*:/i.test(text) ? text : `https://${text}`);
    if (!['http:', 'https:'].includes(url.protocol) || !url.hostname.includes('.') || url.username || url.password) return null;
    return url.href;
  } catch { return null; }
}

export function validateWhatsAppSetup(input = {}) {
  const errors = {};
  if (input.consent !== true || input.website) errors.consent = 'consent_required';
  if (!normalizeStoreUrl(input.store_url)) errors.store_url = 'invalid_store';
  if (typeof input.platform !== 'string' || !input.platform.trim() || input.platform.length > 100) errors.platform = 'required';
  // The shared form client omits empty arrays; no selection means the base plan.
  if (input.automations !== undefined && (!Array.isArray(input.automations) || input.automations.some(id => !AUTOMATION_IDS.includes(id)))) errors.automations = 'invalid_selection';
  if (Array.isArray(input.automations) && input.automations.includes('custom') && (typeof input.details !== 'string' || !input.details.trim())) errors.details = 'required';
  return errors;
}

export function buildWhatsAppSetupPayload(input = {}) {
  const locale = input.locale === 'tr' ? 'tr' : 'en';
  const quote = getWhatsAppQuote(locale, input.automations);
  const details = typeof input.details === 'string' ? input.details.trim().slice(0, 2500) : '';
  const platform = typeof input.platform === 'string' ? input.platform.trim().slice(0, 100) : '';
  return {
    source: 'whatsapp-marketing-landing', category: 'whatsapp_marketing_setup',
    request_status: 'pending_preparation', locale, consent: input.consent === true,
    store_url: normalizeStoreUrl(input.store_url), platform,
    automations: quote.selected, quote, details,
    setup_call_minutes: 20, standard_setup_fee: 0,
    message: [
      'WhatsApp Marketing kurulum talebi / Setup request',
      'Durum: Hazırlık bilgileri gönderilecek / Pending preparation instructions',
      `Store: ${normalizeStoreUrl(input.store_url) || ''}`, `Platform: ${platform}`,
      `Automations: ${quote.selected.join(', ') || 'Base plan only'}`,
      `Monthly: ${quote.monthly} ${quote.currency} (VAT included)`,
      `One-time custom automation setup: ${quote.setup} ${quote.currency} (VAT included)`,
      `Notification bundle discount: ${quote.discount} ${quote.currency}`,
      '1 agent, 1 WhatsApp number. Use alongside the WhatsApp Business App.',
      'Sending fees and Meta charges are separate. No free sending allowance.',
      'Send preparation checklist, then arrange a free 20-minute standard activation appointment.',
      ...(details ? [`Details: ${details}`] : []),
    ].join('\n'),
  };
}
